import React, {useEffect, useState} from "react";
import BlogImagePopper from "./BlogImageLarge";
import zoomImg from "../../../../assets/icons/imgBtn.svg";

import image1 from "../../../../assets/images/Blog15-Images/image1 Blog SPX .png";
import image2 from "../../../../assets/images/Blog15-Images/image2 blog $.png";
import image3 from "../../../../assets/images/Blog15-Images/image3 Blog oil.png";
import image4 from "../../../../assets/images/Blog15-Images/image4 Blog gold.png";

const Blog15 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Intra-week Market Outlook: April 24, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p
          style={{
            textAlign: "justify",
            fontFamily: "var(--header-font-family)",
            fontSize: "30px",
            fontStyle: "normal",
            fontWeight: 700,
            lineHeight: "30px",
            color: "#010310",
          }}
        >
          Financial Markets Update Since Good Friday
        </p>
        <div className="subHeader">
          <p className="">
            {" "}
            The financial markets have experienced significant turbulence since Good Friday, April 18, 2025, driven by geopolitical tensions, trade policy shifts, and macroeconomic signals. Here’s a
            concise recap of the key developments through today, April 24, 2025, along with a preview of major events to watch through the end of this week.
          </p>
          <hr className="divisionLine" />

          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedText_header">Market Movements Since Good Friday</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities Slide and bounce on Trump comments: </span>
                    <span>
                      Since the U.S. markets were closed on Good Friday, that made the weekend seem longer particularly with Trump calling for the demise of Chairman Powell. Easter Monday, April 21,
                      saw little rising with Trump’s words seen as a threat to the independence of the Fed and by association global confidence in the dollar. It seems the US Administration is
                      watching markets because every time there is a catastrophic potential some soothing words come out. Trump did this on Apr 23, over Powell, hinting he didn’t want to remove him
                      now
                    </span>
                  </p>
                </li>

                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">The S&P 500 is up 1.91% on the week currently: </span>
                    <span>
                      the Dow Jones Industrial Average +0.6%, and the Nasdaq100 up 1.33% all reflecting the two-day relief surge. Scott Bessent, US Treasury Secretary initially backed up Trump’s
                      speedy China trade settlement thoughts calling the U.S.-China trade war “unsustainable,” hinting at potential de-escalation. Slight tempering of his view on speed on Thursday by
                      Bessent along with China distancing themselves from being in talks until their respect threshold is met, pressed the pause button on the rally
                    </span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold Surges to Record Highs: </span>
                    <span>
                      Gold has been a standout performer, climbing to a new all-time high of $3,500 per ounce, driven by investor demand for safe-haven assets amid geopolitical uncertainty and
                      tariff-related fears. This quickly reversed 7% to $3,250 on the sentiment flip-flop. Just unwinding the anti-$ and safe haven flows could see a decent pullback in the uptrend
                    </span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Treasury Yields Retreat Slightly: </span>
                    <span>
                      U.S. Treasury yields have eased from recent highs, with the 10-year yield dropping to around 4.35% all week. Investors initially sought safety in bonds amid equity selloffs but
                      correlations are high with US bonds seen as US assets first and another $ to sell. Yields remain elevated compared to early April, signaling ongoing inflation concerns, but it
                      seems Bond vigilantes are being heard now at the Whitehouse
                    </span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">U.S. Dollar Weakens: </span>
                    <span>
                      The U.S. dollar has faced pressure, slipping to a three-year low against major currencies, down over 8% from its 2024 year-end level. This decline has been exacerbated by trade
                      war fears and public criticism of Federal Reserve policies by President Trump, which briefly sparked a selloff in U.S. assets.
                    </span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Tariff Developments Drive Volatility: </span>
                    <span>
                      The markets have been whipsawed by trade policy headlines. Trump’s initial tariff threats, including a 145% rate on Chinese imports, triggered sharp declines earlier in April. A
                      temporary exemption for tech products announced on April 11 provided a brief rally, but renewed criticism of Fed Chair Jerome Powell and China’s retaliatory tariffs kept markets
                      on edge.
                    </span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Earnings Season Mixed: </span>
                    <span>
                      Early Q1 earnings reports have shown resilience, with 76% of S&P 500 companies beating estimates by an average of 6.2%. However, warnings of economic slowdowns due to trade
                      disputes have tempered enthusiasm, particularly in sectors like financials and technology. Tesla’s weaker-than-expected earnings added pressure on tech stocks and is seen as a
                      bottom test for the market. Classic hype stock that should trade in the swap into something else basket
                    </span>
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">The word recession </span>
                    <span>has been mentioned in 43% of reports</span>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <hr className="divisionLine" />

        <div className="subHeader">
          <p className="highlightedBoldText">Key Drivers</p>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv listOfRecap">
                <p>
                  The primary catalyst for market movements has been uncertainty surrounding U.S. trade policies. Trump’s aggressive tariff stance, followed by partial exemptions and retaliatory moves
                  from China, has created a volatile environment. Additionally, Fed Chair Jerome Powell’s cautious stance on interest rates, projecting higher inflation and slower growth due to
                  tariffs, has kept investors wary. <span className="highlightedText">Consumer sentiment has also soured</span>, with the University of Michigan’s April survey dropping to 57.9, the
                  lowest since June 2022, reflecting tariff-related concerns. Hard data though, measures of hiring and buying, have mainly held up.
                </p>
                <p>
                  <span className="highlightedText">Retail giants such as Walmart</span> have visited the President to warn him of the very real potential for{" "}
                  <span className="highlightedText">empty supermarket shelves very soon</span> due to the tariff chaos. Many container ships have not even left China yet so there is a likely shortfall
                  on supplies which will be very easy media images for Trump critics to use.
                </p>
              </div>
            </div>

            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Pepsico has moved forecasts from growth to a 3% loss</span> for Fiscal FY25 on rising production prices and tariff confusion
                    </p>
                  </li>

                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">American Airlines, South West Airlines and Alaska Air all</span> withdrew their full-year guidance after domestic travel demand declined in the
                      first quarter and macro uncertainty made it difficult to chart a flight path!
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">ServiceNow up 10% </span>so not much wrong with AI demand in the year of the Ai agent
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Alphabet and Intel after hours </span>for specific AI and semiconductor demand trends amid the tariff debacle
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">IBM less Big Blue more Big Red -7% </span>on sales miss on discretionary like consultancy
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Data has been light </span>with Global PMIs the highlight with provisional reports for April seeing Services miss expectation in the main.
                      Germany’s IFO surveys saw an uptick across the board. <span className="highlightedText">The Fed’s Beige Book was mucky brown</span> with 107 mentions of Tariffs and 89
                      uncertainties from respondents.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr className="divisionLine" />
        </div>

        <div className="subHeader">
          <p className="highlightedBoldText">Preview: Major Events Through Week’s End (April 25, 2025)</p>
          <div className="subHeader">
            <div className="contentDivWrapper row_reverse">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Friday, April 25: </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">University of Michigan Consumer Sentiment (Final): </span>
                      The preliminary reading showed a sharp decline, and any further deterioration could signal weakening consumer confidence, impacting retail and discretionary stocks.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">UK & Canada Retail Sales: </span>any material weakness from the consumer could reflect in rate cut bets
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Earnings Reports: </span>Key companies like Alphabet, Intel, and Comcast report Thursday, offering insights into tech and consumer sectors.
                      Alphabet’s results could move the Nasdaq, given its weight in the index.
                    </p>
                  </li>
                  <li className="themesPointer">
                    <p>
                      <span className="highlightedText">Trade Policy Updates: </span>China made a very particular rebuttal of any US claims that negotiations were progressing. They denied them having
                      taken place at all.
                    </p>
                  </li>
                </ul>
                <p className="highlightedText_header">Global Macro Data: </p>
                <ul className="pointersSection">
                  <li className="themesPointer">
                    <p>
                      Global flash PMIs for manufacturing and services mainly showed a miss on the Services side, with the tariff impact expected on the goods side of the economic activity. This has
                      the potential to just up the pressure on the recession concerns
                    </p>
                  </li>
                </ul>
              </div>
            </div>

            <hr className="divisionLine" />

            <div className="contentDivWrapper ">
              <div className="contentDiv listOfRecap">
                <p className="highlightedText_header">Outlook</p>

                <p>
                  The markets remain highly sensitive to trade policy developments and Fed rhetoric. While the partial tariff exemptions and Powell’s reaffirmed position have provided some stability,
                  the risk of renewed escalation looms large. Investors should brace for continued volatility, with gold and bonds likely to remain in demand as safe havens. The upcoming earnings and
                  consumer sentiment data will be critical in gauging whether the market can stabilize or if further declines are ahead.
                  <span className="highlightedText">
                    {" "}
                    Is the bottom in yet? Starting to look like 1998, bulls spooked away from buying still high 20x PE for the SPX, Fed likely to eventually cut then boomtime as underweights chase
                    back into the US
                  </span>
                </p>
              </div>
            </div>
            <div className="contentDiv listOfRecap">
              <p className="highlightedText_header">Actionable take-aways</p>

              <p>We’ve already seen one Fake news set up with the 90-day delay on tariffs. Are we being set up for a large China one too?</p>
              <p>Use April 7th lows as ultimate market breakdown otherwise look for continued bullish structure </p>
              <p className="highlightedText">SPX chart</p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image1}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image1)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p>
                Dollar near a significant bottom, expect some churning into it. Momentum improvement setting up for a final low on better MACD…should start seeing good two way markets in dollar pairs
                soon
              </p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image2}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image2)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p>Oil has consolidated and into new OPEC+ supply increase arguments…volume picking up into weak days…are we due a support zone re-test to finish the rally?</p>
              <p className="highlightedText">CL F chart</p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image3}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image3)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="contentDiv listOfRecap">
              <p>
                Gold another big figure notched on the vault wall, $3500, this week. All on a slight wobble about Trump the Dump and his trusty side-kick Powell. It was a threat to $ trust as a
                reserve asset. It’s another chart that may have topped and has a lot of loose hands holding it. The overshoot could be a significant top. No real divergence with momentum though at the
                top so shorts keep the aTH in view for SL
              </p>
            </div>
            <div className="imageWrapperCont">
              <div className="relatedImg">
                <img
                  src={image4}
                  alt=""
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image4)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr className="divisionLine" />
        </div>
        <p>Stay tuned for daily updates on discord as we navigate this dynamic market environment!</p>

        {/* <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/13njWT1IgRI1ezCj8yvh_KsvbUyThaCxVs9KnOxxVjOY/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div> */}
      </div>

      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog15;
